
/* injects from baggage-loader */

const photolibraryDirective = angular.module('photolibrary.setting', []);

photolibraryDirective.directive("photoLibrary", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Modal", "$modal", "Widget", "blockEditDialog",
  ($window, $timeout, $compile, $templateCache, ns, translitService, Modal, $modal, Widget, blockEditDialog) => {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        afterChange: '&'
      },
      templateUrl: settingFolder + "/photo-library/template.jade",
      link: (scope, element, attrs, ngModel) => {

        const setToObject = (obj, value, path) => {
          path = path.split('.');
          let i = 0;
          while (i < path.length - 1) {
            obj = obj[path[i]];
            i++;
          }
          obj[path[i]] = value;
        };

        scope.photoLibraryModal = () => {
          const modalInstance = $modal.open({
            windowTemplateUrl: "./common/templates/window.jade",
            templateUrl: "./editor/modules_settings/photo-library/modal.jade",
            windowClass: "site-settings__modal",
            size: "md",
            controller: "PhotoLibraryCtrl",
            resolve: {
              widget: function() {
                return scope.data;
              }
            }
          });

          modalInstance.result.then((image_url) => {
            const remoteAttr = attrs.accessKey + "." + attrs.remoteKey;
            setToObject(scope.data, image_url, remoteAttr);

            const currentAttr = attrs.accessKey + "." + attrs.currentKey;
            setToObject(scope.data, image_url, currentAttr);

            if (scope.afterChange) {
              scope.afterChange();
            }
          });
        };
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/photo-library/photo-library.directive.js